import { all, call, put, takeLatest } from "redux-saga/effects";
import queryString from "query-string";
import { normalize, schema } from "normalizr";
import { toast } from "react-toastify";

import { getErrorMessage } from "../../../../utils/sagasErrorHandler";
import messageHelper from "../../../../utils/messages/messageHelper";

import {
    createCredentialsTypes,
    deleteCredentialsTypes,
    editCredentialsTypes,
    getCredentialsTypes,
    getCredentialsTypesError,
    getCredentialsTypesSuccess,
    setCredentialsTypesManagerDialog
} from "./actions";
import {
    getCredentialsTypesRequest,
    deleteCredentialsTypesRequest,
    createCredentialsTypesRequest,
    editCredentialsTypesRequest
} from "./api";

const credentialsTypesSchema = new schema.Entity("credentials_types", {},{ idAttribute: "code" });
const credentialsTypesListSchema = new schema.Array(credentialsTypesSchema);

//Workers
function* handleRefreshList() {
    const { search } = window.location;
    yield put(getCredentialsTypes(queryString.parse(search)));
}

function* handleGetCredentialsTypes ({ payload }) {
    try {
        const {count, credentials_types} = yield call(getCredentialsTypesRequest, payload);
        const {result, entities} = normalize(credentials_types, credentialsTypesListSchema);

        yield put(getCredentialsTypesSuccess({
            types: entities.credentials_types,
            credentialsTypes: entities.credentials_types,
            codes: result,
            count
        }));
    } catch (error) {
        yield put(getCredentialsTypesError());
        getErrorMessage(error);
    }
}

function* handleCreateCredentialsTypes ({ payload }) {
    try {
        yield call(createCredentialsTypesRequest, payload);

        yield put(setCredentialsTypesManagerDialog());
        yield call(toast.success, "The credentials type has been successfully created");

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleEditCredentialsTypes ({ payload }) {
    try {
        yield call(editCredentialsTypesRequest, payload);

        yield put(setCredentialsTypesManagerDialog());
        yield call(toast.success, `The credentials type with code - ${payload.code} has been successfully edited`);

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleDeleteCredentialsTypes ({ payload }) {
    try {
        yield all(payload.map((payload) => call(deleteCredentialsTypesRequest, payload)));
        messageHelper({
            type: "success",
            actionSubject: `Credentials type with code - ${payload.join(", ")}`,
            action: "deleted",
            plural: payload.length > 1
        });

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

// Watchers
export function* credentialsTypesSagas() {
    yield all([
        yield takeLatest(getCredentialsTypes, handleGetCredentialsTypes),
        yield takeLatest(createCredentialsTypes, handleCreateCredentialsTypes),
        yield takeLatest(deleteCredentialsTypes, handleDeleteCredentialsTypes),
        yield takeLatest(editCredentialsTypes, handleEditCredentialsTypes)
    ]);
}
